import clsx from 'clsx';
import {FC} from 'react';

export type TagsValueProps = {
    className?: string;
    value: JSX.Element;
};

const CustomValue: FC<TagsValueProps> = ({className, value}) => (
    <div className={clsx('flex flex-wrap gap-2', className)}>{value}</div>
);

export default CustomValue;
